export const contactPerks = [
  'Bezplatná úvodná konzultácia',
  'Odpoveď do 24 hodín',
  'Bez záväzkov',
]

export const proPerks = [
  'HD export návrhov',
  'Neobmedzený počet generovaní',
  'Nákupný zoznam nábytku k návrhu',
]
